import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function TitleComponent({
    downTime,
    duration,
    date,
  }: {
    downTime: boolean | undefined;
    duration: string;
    date: string;
  }) {
    return (
      <Paper elevation={3} sx={{ width: 200 }}>
        <Grid container justifyContent={"center"} flexDirection={"column"}>
          <Grid container padding={"5px 0px 0px 5px"}>
            {downTime === undefined ? (
              <PanoramaFishEyeIcon />
            ) : downTime ? (
              <FmdBadIcon color="error" />
            ) : (
              <CheckCircleIcon color="success" />
            )}
            <Typography
              variant={"subtitle1"}
              fontWeight={700}
              paddingLeft={"10px"}
            >
              {downTime === undefined
                ? "Not Monitored"
                : downTime
                ? "DownTime"
                : "UpTime"}
            </Typography>
          </Grid>
          {downTime && (
            <Grid
              container
              justifyContent={"center"}
              flexDirection={"column"}
              sx={{ padding: "5px 0px 0px 10px" }}
            >
              <Typography>Down for {duration}</Typography>
            </Grid>
          )}
          <div style={{ marginTop: 10 }} />
          <Divider />
          <Typography textAlign={"center"} paddingTop={"5px"}>
            {date}
          </Typography>
        </Grid>
      </Paper>
    );
  }